import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PreventiveMaintenanceService {

  constructor(private http: HttpClient) { }
  uploadFile(file): Observable<any> {
    var formData = new FormData();
    formData.append('media', file);
    return this.http.post(environment.appUrl + 'media/upload', formData, {observe: 'body', withCredentials: true});
  }

  downloadFile(itemId): Observable<any> {

    console.log(itemId);
    const url = environment.appUrl + `media/download`;
    return this.http.post(url, {fileIds: [itemId]}, {
      observe: 'response',
      responseType: 'blob'
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

  createPMPdf(pmId,equipmentDetailsId,imageDescription,file): Observable<any> {
    const url = environment.appUrl + `pms/${pmId}/equipments/${equipmentDetailsId}/image?description=${imageDescription}`;

    return this.http.post(url, file, {observe: 'body', withCredentials: true});
  }

  getPMPdf(pmId,equipmentDetailsId): Observable<any> {
    const url = environment.appUrl + `pms/${pmId}/equipments/${equipmentDetailsId}/special-forms`;

    return this.http.get(url, {observe: 'body', withCredentials: true});
  }

  deletePdf(pmId,equipmentDetailsId,specialFormId): Observable<any> {
    const url = environment.appUrl + `pms/specialForm/pmId/${pmId}/equipmentDetailsId/${equipmentDetailsId}/specialFormId/${specialFormId}/delete`;
  
    return this.http.delete(url, {observe: 'body', withCredentials: true});
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance.service.ts